/*
 *  -----------------------------------------------------------------------
 *    <copyright file="auth-rules.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

interface IAuthCriteria {
    login?: boolean;
    module?: number;
    element?: string;
    isAdmin?: boolean;
    permission?: number;
}

const hasModulePermission = (rights: any, module: number, element: string, permission: number): boolean => {
    const mod = rights.find((m: any) => m.moduleId === module && (!element || m.element === element));
    if (!mod) return false;

    if (!permission) return true;

    return (mod.permissions & permission) === permission;
};

const AuthRules = {
    isValid: (user: any, study: any, criteria: IAuthCriteria) => {
        if (user && user.systemAdminLevel) return true;
        if ((criteria.login || criteria.module) && !user) return false;

        if (!criteria.permission && study)
            // Just make sure they have access to the module through the study
            return (study.modules & criteria.module) > 0;

        if (user) {
            if (!user.role) return false;

            if (criteria.isAdmin) return user.role.isAdmin;

            return (
                criteria.module &&
                user.role.rights &&
                hasModulePermission(user.role.rights, criteria.module, criteria.element, criteria.permission)
            );
        }

        // Not in a study, but looking for module permissions - how to handle?
        return false;
    },
};

export default AuthRules;
